import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SiteLayout } from "./components/site/SiteLayout";
import { ScrollManager } from "./components/site/ScrollManager";
import Home from "./pages/Home";
import InHomeCare from "./pages/InHomeCare";
import Housing from "./pages/Housing";
import Careers from "./pages/Careers";
import Partner from "./pages/Partner";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";
import LogoOptions from "./pages/LogoOptions";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const Protected = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return <div className="min-h-screen grid place-items-center text-sm text-[#5A6561]" data-testid="auth-loading">Checking your session…</div>;
  }
  return user ? children : <Navigate to={`/admin/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
};

function App() {
  return (
    <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/in-home-care" element={<InHomeCare />} />
            <Route path="/housing" element={<Housing />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/partner-with-us" element={<Partner />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/logo-options" element={<LogoOptions />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route element={<AuthProvider><Outlet /></AuthProvider>}>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
